export default "__VITE_ASSET__Cq4ykMI4__"